export enum SurveyEmployeeStatus {
Active,
InActive,
}
